import React from 'react'
import PropTypes from 'prop-types'
import Page from '../../../containers/Request/DetailPage'

const Request = () => (
    <React.Fragment>
        <Page />
    </React.Fragment>
)

Request.propTypes = {
    children: PropTypes.node
}

export default Request